<template>
  <div>
    <el-form
      ref="tableForm"
      :model="formVal"
      :label-position="positionLabel"
      size="small"
      :inline="inline"
    >
      <el-form-item
        v-for="(item,index) in formItems"
        :key="index"
        :label="item.label"
        :prop="item.prop"
      >
        <component
          v-if="item.component"
          :is="$getComponent(item.component)"
          v-model="formVal[item.prop]"
          :form-value="formVal"
          v-bind="item.bind"
          v-on="item.on"
        ></component>
        <span v-html="formatVal(formVal[item.prop],item.format)" v-else>
          
        </span>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "table-form-span",
  props: {
    formVal:Object,
    formItems: Array,
    positionLabel:{
      type: String,
      default: 'left',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: '100px',
    }
  },
  created() {
    
  },
  data() {
    return {
      
    };
  },
  mounted() {
  },
  methods: {
    formatVal(val,format){
      if(format&&typeof format =="function"){
        return format(val,this.formVal);
      }
      return val;
    }
  },
};
</script>